module.exports = __webpack_public_path__ + "media/rest-speak.b0684b50.mp3";